import React from 'react';

function DonorsFund(props) {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            version="1.1"
            {...props}
        >
            <rect
                x="0.5"
                y="0.5"
                width="25"
                height="25"
                rx="12.5"
                stroke="#B0C9EB"
                id="rect41"
            />
            <g id="Group_2651" transform="translate(-465.85755,-269.4365)">
                <g
                    id="Group_2650"
                    transform="matrix(0.22968442,0,0,0.21649625,424.40902,267.77713)"
                >
                    <g
                        id="Group_2644"
                        transform="translate(193.94976,27.263252)"
                    >
                        <g id="Group_2636" transform="translate(23.624,11.403)">
                            <g id="Group_2635">
                                <path
                                    id="Path_1591"
                                    fill="#c36c36"
                                    d="M 48.6,16.9 C 46.5,15 44.2,13.2 41.7,11.8 41.2,11.5 40.6,11.2 40,10.9 c 0,0 0,0 0,0 C 33.4,7.5 26,6 18.7,6.7 12,7.2 5.5,9.5 0,13.4 2.4,10.4 5.4,7.9 8.7,6 13.5,3.2 18.7,1.3 24.2,0.4 25.1,0.3 26,0.1 27,0.1 c 2.9,-0.3 5.9,-0.2 8.8,0.2 2.7,0.4 5.4,1.2 7.9,2.3 3.4,3.3 5.2,8.2 4.9,14.3 z"
                                />
                            </g>
                        </g>

                        <g id="Group_2637" transform="translate(19.67)">
                            <path
                                id="Path_1592"
                                fill="#c36c36"
                                d="M 56.4,18.5 C 54,16.2 51.2,14.3 48.2,13 42.3,10.3 35.5,9.5 28,10.7 22.4,11.6 17,13.5 12.1,16.4 8.1,18.7 4.6,21.8 2,25.6 3.7,20 8,14.3 14.2,9.4 20.9,4.2 28.9,0.7 35.7,0.1 c 7.2,-0.6 12.9,1.1 16.7,5 3.1,3.7 4.6,8.6 4,13.4 z"
                            />

                            <path
                                id="Path_1593"
                                fill="#c36c36"
                                d="m 0,31 v 0 c 0,-0.1 0,-0.1 0,-0.1 z"
                            />
                        </g>

                        <g id="Group_2639" transform="translate(39.833,28.936)">
                            <g id="Group_2638">
                                <path
                                    id="Path_1594"
                                    fill="#c36c36"
                                    d="m 0,40.4 c 2.7,-0.8 5.4,-2 7.9,-3.4 0.5,-0.3 1.1,-0.6 1.6,-1 0,0 0,0 0,0 6.2,-4 11.2,-9.7 14.3,-16.4 2.9,-6.1 4.1,-12.8 3.5,-19.5 1.4,3.6 2.1,7.4 2,11.2 0.1,5.5 -0.9,11 -2.9,16.2 -0.3,0.9 -0.7,1.7 -1.1,2.5 -1.2,2.7 -2.8,5.2 -4.6,7.5 C 19,39.7 17,41.6 14.8,43.2 10.2,44.6 5.1,43.6 0,40.4 Z"
                                />
                            </g>
                        </g>

                        <g id="Group_2640" transform="translate(46.359,22.455)">
                            <path
                                id="Path_1595"
                                fill="#c36c36"
                                d="m 0,55 c 3.2,-0.9 6.2,-2.4 8.9,-4.3 5.3,-3.8 9.4,-9.3 12.2,-16.4 2,-5.3 3,-11 3,-16.7 C 24.1,13 23.2,8.4 21.2,4.2 25.2,8.6 28,15.1 29,23 30.2,31.4 29.2,40.1 26.3,46.2 23.2,52.7 18.9,56.9 13.7,58.1 8.9,59.1 3.9,58 0,55 Z"
                            />

                            <path
                                id="Path_1596"
                                fill="#c36c36"
                                d="m 17.4,0 v 0 c 0.1,0 0.1,0.1 0,0 z"
                            />
                        </g>

                        <g id="Group_2642" transform="translate(10.712,20.728)">
                            <g id="Group_2641">
                                <path
                                    id="Path_1597"
                                    fill="#c36c36"
                                    d="m 9.8,0 c -0.6,2.8 -1,5.7 -0.9,8.5 0,0.6 0,1.2 0,1.9 0,0 0,0 0,0.1 0.4,7.4 2.8,14.5 7,20.5 3.8,5.6 9.1,10 15.2,12.8 C 27.3,43.2 23.7,41.9 20.4,40 15.6,37.3 11.3,33.7 7.8,29.4 7.2,28.7 6.7,27.9 6.1,27.2 4.4,24.8 3,22.2 1.9,19.5 0.9,16.9 0.2,14.3 -0.1,11.5 1,6.7 4.4,2.8 9.8,0 Z"
                                />
                            </g>
                        </g>

                        <g id="Group_2643" transform="translate(0,22.297)">
                            <path
                                id="Path_1598"
                                fill="#c36c36"
                                d="m 10.1,0 c -0.8,3.2 -1,6.6 -0.7,9.9 0.6,6.5 3.4,12.8 8.1,18.7 3.6,4.4 8,8.1 12.9,10.9 4,2.3 8.4,3.8 13,4.2 C 37.7,45 30.6,44.2 23.3,41.2 15.4,38 8.4,32.8 4.5,27.2 0.4,21.3 -1,15.4 0.5,10.3 2.1,5.6 5.6,1.9 10.1,0 Z"
                            />

                            <path
                                id="Path_1599"
                                fill="#c36c36"
                                d="m 49.1,42.6 v 0 c -0.1,0 -0.1,0 0,0 z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default DonorsFund;
